/**
 * botTurretDive — refuse champ/minion dives under enemy turret without wave (FID-BOT-14).
 *
 * Pure JS — no Three.js, no DOM.
 */

import { isMinionEntity } from './botWaveFollow.js';

export const TURRET_DIVE_MINION_RADIUS = 8;

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

function distance2d(a, b) {
  return Math.hypot(b.x - a.x, entityZ(b) - entityZ(a));
}

function isEnemyTurret(entity, team) {
  if (!entity || entity.isDead || entity.team === team) return false;
  const t = String(entity.type || '');
  return t === 'turret' || t === 'inhibitorTurret';
}

function sandboxTurretRange(turret) {
  const raw = Number(turret?.attackRange);
  if (Number.isFinite(raw) && raw > 0) return raw / 100;
  return 7.5;
}

function coveringTurret(pos, allEntities, team) {
  for (const entity of allEntities) {
    if (!isEnemyTurret(entity, team)) continue;
    if (distance2d(pos, entity) <= sandboxTurretRange(entity)) return entity;
  }
  return null;
}

export function isUnderEnemyTurret(pos, allEntities = [], team) {
  return coveringTurret(pos, allEntities, team) !== null;
}

function alliedMinionNearTurret(turret, allEntities, team) {
  for (const entity of allEntities) {
    if (!entity || entity.isDead || entity.team !== team) continue;
    if (!isMinionEntity(entity)) continue;
    if (distance2d(turret, entity) <= TURRET_DIVE_MINION_RADIUS) return true;
  }
  return false;
}

function isStructureTarget(target) {
  const t = String(target?.type || '');
  return t === 'turret' || t === 'inhibitorTurret' || t === 'inhibitor' || t === 'nexus';
}

export function shouldRefuseDive(bot, target, allEntities = []) {
  if (!bot || !target || isStructureTarget(target)) return false;
  const turret = coveringTurret(target, allEntities, bot.team);
  if (!turret) return false;
  return !alliedMinionNearTurret(turret, allEntities, bot.team);
}
